import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AccountState {
  loading: boolean;
  accountDetails: any | null;
  error: string | null;
}

const initialState: AccountState = {
  loading: false,
  accountDetails: null,
  error: null,
};

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    accountRequest(state, action: PayloadAction<string>) {
      // Accepts accountId as a payload
      state.loading = true;
      state.error = null;
    },
    accountFetched(state, action: PayloadAction<any>) {
      state.loading = false;
      state.accountDetails = action.payload;
      state.error = null;
    },
    accountFetchFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetAccountSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const {
  accountRequest,
  accountFetched,
  accountFetchFailed,
  resetAccountSlice,
} = accountSlice.actions;

export default accountSlice.reducer;
